import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { GenericModal } from "@Shared/components/modals";
import TimelineNote from "../timeline-note";
import EmailConvert from "./email-convert";
import FollowUpTab from "../../actions-panel/follow-up-tab";
import { cleanHTML } from "@Shared/utils/utils";
import { cloneDeep, startCase, upperCase } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActivityConvertModal",
  components: {
    GenericModal,
    TimelineNote,
    FollowUpTab,
    EmailConvert
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      currentItemId: 0,
      currentItemType: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("BoardStore", {
    profileData(state) {
      return state.clientProfiles.byId[this.clientProfileId];
    }
  })), {}, {
    timelineItem() {
      var _context;
      const timelineItems = this.profileData.timeline.byId;
      return timelineItems[this.currentItemId] || _reduceInstanceProperty(_context = _Object$values(timelineItems)).call(_context, (latest, item) => new Date(item.createdAt) > new Date(latest.createdAt) && item.activityType === "email" ? item : latest);
    }
  }),
  methods: {
    handleShow() {
      const {
        id,
        activityType
      } = this.$refs.modal.modalData;
      this.currentItemId = id;
      this.currentItemType = activityType;
    },
    handleShown(activityType) {
      this.$nextTick(() => {
        this.$refs.followUpTab.initTab();
        if (activityType === "email") {
          this.$refs.timelineComponent.resizeIFrame();
        }
      });
    },
    handleItemAdd() {
      this.$refs.modal.hide();
    },
    getTimelineComponent(activityType) {
      if (activityType === "email") return "email-convert";
      return `timeline-${activityType}`;
    },
    getTabData(activityType) {
      const followUpData = {
        description: `${upperCase(this.$t("global.words.from"))} ${upperCase(activityType)}: \n`
      };
      if (activityType === "note") {
        followUpData.description += this.timelineItem.note;
      }
      if (activityType === "email") {
        followUpData.description += cleanHTML(this.timelineItem.body);
      }
      return cloneDeep(followUpData);
    },
    startCase(string) {
      return startCase(string);
    }
  }
});